import NoSearchResultsCard from './Search/noSearchResultsCard'
import SearchForm from './Search/SearchForm'
import SearchResults from './Search/searchResults'
import { INITIAL_SEARCH_FILTERS, SearchFilterProps } from '../hooks/search'
import { useTranslation } from 'react-i18next'
import VCULinks from './Search/VCULinks'
import { vcuSKUs } from '@/data/vcu_skus'
import { LoadingSpinner } from './ui/loadingSpinner'

function VirtualInstructorCourses({
  searchParams,
  instructorList,
  searchResults,
  onSearch,
  onReset,
  activeCourseType,
  loading,
}) {
  const { t } = useTranslation('pages')
  const rawBullets = t('virtual_classroom.bullets', {
    returnObjects: true,
  })
  const bullets = Array.isArray(rawBullets) ? rawBullets : []

  const convertParamsToFilters = (
    params: URLSearchParams
  ): SearchFilterProps => {
    return {
      ...INITIAL_SEARCH_FILTERS,
      ...Object.fromEntries(params.entries()),
    } as SearchFilterProps
  }

  return (
    <>
      <div className="bg-grays-light p-6 w-full rounded-b flex flex-col text-grays-dark h-full border-x border-b border-grays-lightmedium shadow">
        <div className="flex justify-between flex-col lg:flex-row gap-4 mt-2">
          <div className="basis-full lg:basis-1/4 leading-8 mb-4 pr-2">
            <p className="mb-2 leading-6 font-medium">
              {t('virtual_classroom.description')}
            </p>
            <ul className="list-disc list-outside pl-4 leading-6">
              {bullets.map((bullet, index) => (
                <li className="mb-2" key={index}>
                  {bullet}
                </li>
              ))}
            </ul>
          </div>
          <div className="basis-full lg:basis-3/4">
            <VCULinks vcuPlans={vcuSKUs} />
          </div>
        </div>
      </div>
      <div className="sm:flex w-full mt-4">
        <div className="sm:mr-4 items-stretch basis-auto sm:basis-1/2 lg:basis-1/3">
          <SearchForm
            key={searchParams.toString()}
            onReset={onReset}
            onSearch={onSearch}
            instructorList={instructorList}
            initialValues={convertParamsToFilters(searchParams)}
            activeCourseType={activeCourseType}
          />
        </div>
        <div
          className="frontpage-image self-end hidden basis-0 rounded-sm sm:block sm:basis-1/2 lg:basis-2/3"
          role="img"
          aria-label="mechanics diagnosing car"
        ></div>
      </div>
      <section className="container mx-auto mt-4">
        <div className="flex justify-between">
          <h4 className="text-sm text-secondary font-medium mb-2">
            {searchResults.length} Results Found
          </h4>
          <button
            type="button"
            className="text-primary hover:underline rounded text-sm mb-2"
            onClick={onReset}
          >
            Clear Search
          </button>
        </div>
        <div className="relative max-h-320 overflow-x-auto rounded-sm border-y border-grays-mediumlight">
          {loading && (
            <LoadingSpinner
              variant="parent"
              overlayClassName="bg-white/70 dark:bg-black/40"
            />
          )}
          <div>
            {searchResults.length ? (
              <SearchResults results={searchResults} />
            ) : (
              <NoSearchResultsCard />
            )}
          </div>
        </div>
      </section>
    </>
  )
}

export default VirtualInstructorCourses
